import styled from 'styled-components';
import { colours, media, slideToRightArrowsAnimation, spacing, zBase } from '@storefront/lib-global/stylings';

export const MediaContainer = styled.div<{ $isPaginationDynamic?: boolean; $dynamicPaginationXPosition?: string }>`
  margin: 0 -${spacing.S};
  position: relative;
  z-index: ${zBase};

  @media ${media.greaterThan('lg')} {
    margin: unset;
    max-height: 745px;
    max-width: 745px;
    width: 100%;
  }

  .swiper-button-disabled {
    pointer-events: none;
    span {
      opacity: 0.3;
    }
  }

  .swiper-button-lock {
    display: none;
  }

  .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    transform: unset;
    width: 1000px;
  }

  .pdp-media-pagination {
    align-items: ${({ $isPaginationDynamic }) => !$isPaginationDynamic && 'center'};
    display: ${({ $isPaginationDynamic }) => !$isPaginationDynamic && 'flex'};
    height: 10px;
    margin: 0;
    padding: 0;
    transform: unset;
    width: auto;

    .swiper-pagination-bullet {
      background: ${colours.WHITE};
      border: 0.8px solid ${colours.BLACK};
      border-radius: 0;
      height: 3px;
      margin: 0 3px;
      opacity: 1;
      transform: ${({ $dynamicPaginationXPosition }) => $dynamicPaginationXPosition || 'translateX(-270%)'};
      width: 19px;
    }

    .swiper-pagination-bullet-active {
      background: ${colours.TURQUOISE};
      border: 1px solid ${colours.TURQUOISE};
      height: 8px;
      width: 19px;
    }
  }

  .swiper {
    .swiper-button-next::after,
    .swiper-button-prev::after {
      display: none;
    }
    .swiper-button-next,
    .swiper-button-prev {
      background-color: ${colours.BLACK};
      background-image: none;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% auto;
      border-radius: 50%;
      height: 200px;
      width: 200px;
    }
  }
`;
export const MediaSlide = styled.div`
  aspect-ratio: 1 / 1;
  position: relative;
  width: 100%;

  video {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
`;
export const MediaImageGrid = styled.div`
  display: none;
  @media ${media.greaterThan('lg')} {
    display: flex;
    flex-wrap: wrap;
    gap: ${spacing.XXXS};
    margin-top: ${spacing.XS};
    max-width: 745px;
    width: 100%;
  }
`;
export const MediaImageGridItem = styled.div`
  aspect-ratio: 1 / 1;
  border: 1px solid transparent;
  cursor: pointer;
  flex: 49%;
  max-width: 49.5%;
  position: relative;

  video {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
`;
export const MediaImageGridItemHighlight = styled.div<{ $selectedSlide: boolean }>`
  background-color: ${({ $selectedSlide }) => ($selectedSlide ? `${colours.TURQUOISE}` : 'transparent')};
  bottom: 0%;
  height: 9px;
  padding: 0px 2px 2px;
  position: absolute;
  width: 100%;
`;
export const ZoomButton = styled.button`
  align-items: center;
  aspect-ratio: 1 / 1;
  background: transparent;
  border: 0;
  cursor: zoom-in;
  display: flex;
  height: 32px;
  justify-content: center;
  padding: 0;
  pointer-events: auto;
  position: absolute;
  width: 32px;

  z-index: 1;

  svg {
    display: inline-block;
    margin: 0;
    overflow: visible;
  }

  @media ${media.greaterThan('md')} {
    height: 40px;
    width: 40px;
  }
  @media ${media.greaterThan('lg')} {
    left: 91%;
    top: -30%;
  }
  @media ${media.greaterThan('xl')} {
    left: 93%;
    top: unset;
  }
`;
export const NavigationButton = styled.button`
  display: none;
  @media ${media.greaterThan('lg')} {
    background: none;
    border: none;
    display: block;
    height: 75%;
    padding: ${spacing.M};
    position: absolute;
    top: 0%;
    z-index: 2;
    &.pdp-media-next {
      left: 97%;
      transform: translate(-95%, 10%);
      &:hover,
      &:focus {
        span {
          ${slideToRightArrowsAnimation}
        }
      }
    }

    &.pdp-media-prev {
      left: 3%;
      transform: translate(-5%, 10%);
      &:hover,
      &:focus {
        span {
          ${slideToRightArrowsAnimation}
        }
      }
    }
  }
`;
export const NavigationButtonIcon = styled.span`
  align-items: center;
  aspect-ratio: 1/1;
  background: ${colours.WHITE};
  border: 1px solid ${colours.BLACK};
  border-radius: 50%;
  display: flex;
  height: 20px;
  justify-content: center;
  width: 20px;

  svg {
    display: inline-block;
    margin: 0;
    overflow: visible;
    transform: scale(0.5);
  }
`;
export const PaginationContainer = styled.div`
  align-items: flex-end;
  display: flex;
  height: 30px;
  justify-content: center;
  pointer-events: none;
  position: absolute;
  width: 100%;
  z-index: 1;

  ${ZoomButton} {
    display: none;
  }

  @media ${media.greaterThan('md')} {
    height: 40px;
  }

  @media ${media.greaterThan('lg')} {
    align-items: center;
    top: 93%;

    ${ZoomButton} {
      display: flex;
    }
  }
`;

export const MobileZoomContainer = styled.div`
  display: block;
  height: 32px;
  left: 8px;

  pointer-events: none;
  position: absolute;
  right: 24px;
  top: 8px;
  width: 32px;
  z-index: 1;

  @media ${media.greaterThan('lg')} {
    display: none;
  }

  @media ${media.greaterThan('md')} {
    height: 40px;
    width: 40px;
  }
`;

export const BannerSlotContainer = styled.div`
   {
    margin-top: 50px;

    @media ${media.greaterThan('lg')} {
      margin-top: 20px;
    }
  }
`;
